import React, { ReactNode } from 'react';
import { NotificationProvider } from '@/Context/NotificationContext';
import { Toaster } from '../shadcn';

export interface NotificationSystemProps {
    children: ReactNode;
}

function NotificationSystem({ children }: NotificationSystemProps): React.JSX.Element {
    return (
        <NotificationProvider>
            {children}
            <Toaster position="bottom-left" closeButton />
        </NotificationProvider>
    );
}

export default NotificationSystem;
